<script setup lang="ts">
import { Tippy } from 'vue-tippy';
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import type { BubbleMenuTooltipButtonProps } from './bubble-menu-tooltip-button';

const ICON_SIZE = 18;

withDefaults(defineProps<BubbleMenuTooltipButtonProps>(), {
  isActive: false,
  keyboardShortcut: undefined,
});

const emits = defineEmits<{
  click: [];
}>();
</script>

<template>
  <Tippy :arrow="false" placement="top" :offset="[0, 2]" theme="tiptap-tippy">
    <template #default>
      <button
        type="button"
        class="bubble-menu-tooltip-button"
        :class="{ 'bubble-menu-tooltip-button-active': isActive }"
        :aria-label="description"
        @mousedown.prevent
        @click="emits('click')"
      >
        <HugeIcon :icon="icon" :size="ICON_SIZE" />
      </button>
    </template>
    <template #content>
      <div
        v-if="description || keyboardShortcut"
        class="flex flex-col items-center gap-1 rounded-md bg-neutral-800 p-1 text-white shadow-md"
      >
        <div>{{ description }}</div>
        <kbd v-if="keyboardShortcut" class="flex gap-1">
          <template
            v-for="(part, index) of keyboardShortcut.parts()"
            :key="index"
          >
            <kbd
              class="flex min-w-[20px] items-center justify-center rounded-md border p-[0.1rem] text-xs leading-3"
            >
              {{ part }}
            </kbd>
            <template v-if="index < keyboardShortcut.parts().length - 1"
              >+</template
            >
          </template>
        </kbd>
      </div>
    </template>
  </Tippy>
</template>

<style scoped>
.bubble-menu-tooltip-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  padding: 0 0.5rem;
  color: var(--color-neutral-700);
}

.bubble-menu-tooltip-button:hover {
  background: var(--color-neutral-100);
}

.bubble-menu-tooltip-button-active {
  background: var(--color-neutral-200);
}
</style>
